<template>
  <div class="report-yk-container">
    <!-- 左右布局容器 -->
    <el-container class="main-layout">
      <!-- 左侧树形菜单 - 宽度调整为20% -->
      <!-- <el-aside class="left-sidebar" width="10%"> -->
        <!-- 左侧树形菜单内容保持不变 -->
       <!-- <div class="sidebar-header">
          <h3 class="sidebar-title">中药库信息统计报表</h3>
        </div>
        <div class="tree-container">
          <el-tree
            ref="orgTree"
            :data="treeData"
            :props="treeProps"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            class="custom-tree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <i :class="data.icon" class="tree-icon"></i>
              <span class="tree-label">{{ node.label }}</span>
              <span v-if="data.count" class="tree-count">({{ data.count }})</span>
            </span>
          </el-tree>
        </div>
      </el-aside> -->

      <!-- 右侧主要内容区域 - 宽度调整为80% -->
      <el-main class="right-content">
        <!-- 标签页容器 -->
        <div class="tab-container">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <!-- 第一个标签页：表格详情统计 -->
            <el-tab-pane label="表格详情统计" name="table">
              <div class="tab-content">
                <!-- 表格区域 -->
                <div class="table-section">
                  <div class="table-header">
                    <h3 class="table-title">中药库信息统计报表</h3>
                    <div class="table-actions">
                      <!-- 顶部搜索栏 - 高度调整为10% -->
                      <div class="search-header">
                        <div class="search-left">
                          <!-- 新增：日期范围选择器 -->
                          <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleDateChange"
                            size="mini"
                            class="date-range-picker"
                          >
                          </el-date-picker>
                          
                          <el-input
                            v-model="searchKeyword"
                            placeholder="请输入药品名称或批号"
                            class="search-input"
                            clearable
                            size="mini"
                          >
                            <el-button slot="append" icon="el-icon-Ssearch" @click="handleSearch">搜索</el-button>
                          </el-input>
                        </div>
                        <div class="search-right">
                          <el-button size="mini" type="primary" icon="el-icon-refresh" @click="refreshData">刷新</el-button>
                          <el-button size="mini" type="primary" icon="el-icon-download" @click="exportData">导出</el-button>
                        </div>
                      </div>
                    </div>
                  </div>

                <el-table
                  :data="tableData"
                  style="width: 100%"
                  border
                  stripe
                  v-loading="loading"
                  @selection-change="handleSelectionChange"
                  :height="tableHeight"
                >
                  <!-- 表格列定义保持不变 -->
                  <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                  <el-table-column prop="id" label="系统序号" fixed="left" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.id" placement="top" v-if="scope.row.id && scope.row.id.length > 10">
                        <span>{{ scope.row.id.substring(0, 10) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.id }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="drugName" label="药品名称" width="140" align="left">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.drugName" placement="top" v-if="scope.row.drugName && scope.row.drugName.length > 8">
                        <span>{{ scope.row.drugName.substring(0, 8) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.drugName }}</span>
                    </template>
                  </el-table-column>
                  <!-- 其他表格列保持不变 -->
                  <el-table-column prop="drugCode" label="药品编码" width="140" align="left">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.drugCode" placement="top" v-if="scope.row.drugCode && scope.row.drugCode.length > 8">
                        <span>{{ scope.row.drugCode.substring(0, 12) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.drugCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="drugSpec" label="药品规格" width="160" align="center">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.drugSpec" placement="top" v-if="scope.row.drugSpec && scope.row.drugSpec.length > 8">
                        <span>{{ scope.row.drugSpec.substring(0, 8) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.drugSpec }}</span>
                    </template>
                  </el-table-column>
                
                  <el-table-column prop="unt" label="计量单位" width="80" align="center">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.unt" placement="top" v-if="scope.row.unt && scope.row.unt.length > 4">
                        <span>{{ scope.row.unt.substring(0, 4) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.unt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="purcPric" label="成本单价" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="price-value">¥{{ scope.row.purcPric }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="salePric" label="销售单价" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="leave-active">¥{{ scope.row.salePric }}</span>
                    </template>
                  </el-table-column>
                  <!-- 库存期初 - 合并期初相关字段 -->
                  <el-table-column label="库存期初" align="center">
                    <!-- 期初数量 -->
                    <el-table-column prop="startCnt" label="期初数量" width="80" align="center"></el-table-column>
                    <!-- 期初成本 -->
                    <el-table-column prop="startPurcAmt" label="期初成本" width="80" align="center">
                      <template slot-scope="scope">
                        <span class="price-value">¥{{ scope.row.startPurcAmt }}</span>
                      </template>
                    </el-table-column>
                    <!-- 期初零售 -->
                    <el-table-column prop="startSaleAmt" label="期初零售" width="80" align="center">
                      <template slot-scope="scope">
                        <span class="leave-active">¥{{ scope.row.startSaleAmt }}</span>
                      </template>
                    </el-table-column>
                </el-table-column>
                
                <!-- 库存期末 - 合并期末相关字段 -->
                <el-table-column label="库存期末" align="center">
                  <el-table-column prop="endCnt" label="期末数量" width="80" align="center"></el-table-column>
                  <el-table-column prop="endPurcAmt" label="期末成本" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="price-value">¥{{ scope.row.endPurcAmt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="endSaleAmt" label="期末零售" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="leave-active">¥{{ scope.row.endSaleAmt }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                
                <!-- 本期库存入库 - 合并入库相关字段 -->
                <el-table-column label="本期入库" align="center">
                  <el-table-column prop="intoCnt" label="入库数量" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="number-highlight">{{ scope.row.intoCnt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="intoPurcAmt" label="入库成本" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="price-value">¥{{ scope.row.intoPurcAmt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="intoSaleAmt" label="入库零售" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="leave-active">¥{{ scope.row.intoSaleAmt }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                
                <!-- 本期库存出库 - 合并入库相关字段 -->
                <el-table-column label="本期出库" align="center">
                	<el-table-column prop="outCnt" label="出库数量" width="80" align="center"></el-table-column>
                	<el-table-column prop="outPurcAmt" label="出库成本" width="80" align="center">
                	  <template slot-scope="scope">
                	    <span class="price-value">¥{{ scope.row.outPurcAmt }}</span>
                	  </template>
                	</el-table-column>
                	<el-table-column prop="outSaleAmt" label="出库零售" width="80" align="center">
                	  <template slot-scope="scope">
                	    <span class="leave-active">¥{{ scope.row.outSaleAmt }}</span>
                	  </template>
                	</el-table-column>
                </el-table-column>
                
                <!-- 本期库存调拨 - 合并入库相关字段 -->
                <el-table-column label="本期调拨入库" align="center">
                	<el-table-column prop="allotIntoCnt" label="调拨入库数量" width="140" align="center"></el-table-column>
                	<el-table-column prop="allotIntoPurcAmt" label="调拨入库成本" width="140" align="center">
                	  <template slot-scope="scope">
                	    <span class="price-value">¥{{ scope.row.allotIntoPurcAmt }}</span>
                	  </template>
                	</el-table-column>
                	<el-table-column prop="allotIntoSaleAmt" label="调拨入库零售" width="140" align="center">
                	  <template slot-scope="scope">
                	    <span class="leave-active">¥{{ scope.row.allotIntoSaleAmt }}</span>
                	  </template>
                	</el-table-column>
                </el-table-column>
                	
                <!-- 本期库存调拨 - 合并入库相关字段 -->
                <el-table-column label="本期调拨出库" align="center">
                	<el-table-column prop="allotOutCnt" label="调拨出库数量" width="140" align="center"></el-table-column>
                	<el-table-column prop="allotOutPurcAmt" label="调拨出库成本" width="140" align="center">
                	  <template slot-scope="scope">
                	    <span class="price-value">¥{{ scope.row.allotOutPurcAmt }}</span>
                	  </template>
                	</el-table-column>
                	<el-table-column prop="allotOutSaleAmt" label="调拨出库零售" width="140" align="center">
                	  <template slot-scope="scope">
                	    <span class="leave-active">¥{{ scope.row.allotOutSaleAmt }}</span>
                	  </template>
                	</el-table-column>
                </el-table-column>
                <!-- 本期盘盈盘亏 - 合并入库相关字段 -->
                <el-table-column label="盘盈盘亏" align="center">
                  <el-table-column prop="stockLossCnt" label="盘亏数量" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="number-highlight">{{ scope.row.stockLossCnt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stockLossPurcAmt" label="盘亏成本" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="price-value">¥{{ scope.row.stockLossPurcAmt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stockLossSaleAmt" label="盘亏零售" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="leave-active">¥{{ scope.row.stockLossSaleAmt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stockProfitCnt" label="盘盈数量" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="number-highlight">{{ scope.row.stockProfitCnt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stockProfitPurcAmt" label="盘盈成本" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="price-value">¥{{ scope.row.stockProfitPurcAmt }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stockProfitSaleAmt" label="盘盈零售" width="80" align="center">
                    <template slot-scope="scope">
                      <span class="leave-active">¥{{ scope.row.stockProfitSaleAmt }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                  <el-table-column prop="manuLotnum" label="生产批号" width="140" align="center">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.manuLotnum" placement="top" v-if="scope.row.manuLotnum && scope.row.manuLotnum.length > 10">
                        <span>{{ scope.row.manuLotnum.substring(0, 10) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.manuLotnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="prodentpName" label="生产厂家" width="180" align="center">
                    <template slot-scope="scope">
                      <el-tooltip :content="scope.row.prodentpName" placement="top" v-if="scope.row.prodentpName && scope.row.prodentpName.length > 8">
                        <span>{{ scope.row.prodentpName.substring(0, 8) }}...</span>
                      </el-tooltip>
                      <span v-else>{{ scope.row.prodentpName }}</span>
                    </template>
                  </el-table-column>
                
                  <el-table-column label="操作" width="80" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" icon="el-icon-Ssearch" @click="handleView(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                  <!-- 分页 -->
                  <div class="pagination-container">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <!-- 第二个标签页：图表详情统计 -->
            <el-tab-pane label="图表详情统计" name="chart">
              <div class="tab-content">
                <!-- 图表区域 -->
                <div class="chart-section">
                  <div class="chart-header">
                    <h3 class="chart-title">进销存数据分析报表</h3>
                    <div class="chart-actions">
                      <el-select v-model="chartType" size="mini" placeholder="图表类型" @change="updateChart" style="width: 120px; margin-right: 10px;">
                        <el-option label="柱状图" value="bar"></el-option>
                        <el-option label="饼图" value="pie"></el-option>
                        <el-option label="折线图" value="line"></el-option>
                        <el-option label="散点图" value="scatter"></el-option>
                        <el-option label="K线图" value="candlestick"></el-option>
                        <el-option label="旭日图" value="sunburst"></el-option>
                        <el-option label="盒须图" value="boxplot"></el-option>
                      </el-select>
                      
                      <el-select v-model="chartMetric" size="mini" placeholder="指标选择" @change="updateChart" style="width: 120px;">
                        <el-option label="入库数量" value="intoCnt"></el-option>
                        <el-option label="出库数量" value="outCnt"></el-option>
                        <el-option label="期初数量" value="startCnt"></el-option>
                        <el-option label="期初成本" value="startPurcAmt"></el-option>
                        <el-option label="期初零售" value="startSaleAmt"></el-option>
                        <el-option label="期末数量" value="endCnt"></el-option>
                        <el-option label="期末成本" value="endPurcAmt"></el-option>
                        <el-option label="期末零售" value="endSaleAmt"></el-option>
                      </el-select>
                    </div>
                  </div>
                  
                  <!-- 关键指标卡片 - 调整为6个卡片 -->
                  <div class="metrics-cards">
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon profit">
                          <i class="el-icon-money"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.totalProfit) }}</div>
                          <div class="metric-label">利润总额</div>
                        </div>
                      </div>
                    </el-card>
                    
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon daily">
                          <i class="el-icon-data-line"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.dailyAverage) }}</div>
                          <div class="metric-label">日均总额</div>
                        </div>
                      </div>
                    </el-card>
                    
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon price">
                          <i class="el-icon-price-tag"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.unitPrice) }}</div>
                          <div class="metric-label">期初成本</div>
                        </div>
                      </div>
                    </el-card>
                    
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon cost">
                          <i class="el-icon-truck"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.transportCost) }}</div>
                          <div class="metric-label">期初零售</div>
                        </div>
                      </div>
                    </el-card>
                    
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon end-cost">
                          <i class="el-icon-bank-card"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.endCost) }}</div>
                          <div class="metric-label">期末成本</div>
                        </div>
                      </div>
                    </el-card>
                    
                    <el-card class="metric-card" shadow="hover">
                      <div class="metric-content">
                        <div class="metric-icon end-sale">
                          <i class="el-icon-shopping-cart-2"></i>
                        </div>
                        <div class="metric-info">
                          <div class="metric-value">{{ formatNumber(metrics.endSale) }}</div>
                          <div class="metric-label">期末零售</div>
                        </div>
                      </div>
                    </el-card>
                  </div>

                  <!-- ECharts图表 - 修复宽度问题 -->
                  <div class="chart-container" ref="chartContainer">
                    <div ref="salesChart" class="sales-chart"></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { dgsReportZY } from "@/api/PSI/report.js";

export default {
  name: 'ReportYK',
  data() {
    return {
      // 新增：日期范围选择器数据
      dateRange: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      
      // 新增：表格高度自适应
      tableHeight: 500,
      
      // 标签页相关数据
      activeTab: 'table', // 默认激活表格标签页
      
      // 搜索相关
      searchKeyword: '',
      
      // 图表配置 - 默认按入库数量展示
      chartType: 'bar',
      chartMetric: 'intoCnt',
      
      // 树形控件数据
      treeData: [
        {
          id: 1,
          label: '中药库',
          icon: 'el-icon-office-building',
          children: [
            { id: 11, label: '采购入库', icon: 'el-icon-money', count: 15 },
            { id: 12, label: '药品调拨', icon: 'el-icon-user', count: 8 },
            { id: 13, label: '药品盘点', icon: 'el-icon-monitor', count: 12 }
          ]
        },
        {
          id: 2,
          label: '中药库',
          icon: 'el-icon-office-building',
          children: [
            { id: 21, label: '采购入库', icon: 'el-icon-cpu', count: 20 },
            { id: 22, label: '药品调拨', icon: 'el-icon-truck', count: 5 },
            { id: 23, label: '药品盘点', icon: 'el-icon-lock', count: 10 }
          ]
        },
      ],
      treeProps: {
        children: 'children',
        label: 'label'
      },

      // 表格数据
      tableData: [],
      
      // 指标数据 - 调整为6个指标
      metrics: {
        totalProfit: 0,      // 利润总额 = 成本金额累加
        dailyAverage: 0,     // 日均总额 = 零售金额
        unitPrice: 0,       // 期初成本
        transportCost: 0,   // 期初零售
        endCost: 0,         // 期末成本
        endSale: 0          // 期末零售
      },
      
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      
      // 图表实例
      chartInstance: null,
      
      // 选中的行
      multipleSelection: [],
      
      // 窗口大小变化监听器
      resizeObserver: null
    };
  },
  mounted() {
    this.initDefaultDateRange(); // 初始化默认日期范围
    this.initChart();
    this.fetchReportData();
    this.setupResizeObserver();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 新增：初始化默认日期范围（上个月初到今天）
    initDefaultDateRange() {
      const today = new Date();
      const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      
      this.dateRange = [
        this.formatDate(firstDayOfLastMonth),
        this.formatDate(today)
      ];
    },
    
    // 新增：日期格式化方法
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 新增：日期范围变化处理
    handleDateChange(value) {
      console.log('日期范围变化:', value);
      if (value && value.length === 2) {
        this.fetchReportData();
      }
    },
    
    // 新增：设置窗口大小变化监听器
    setupResizeObserver() {
      // 使用 ResizeObserver 监听图表容器大小变化
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            if (entry.target === this.$refs.chartContainer) {
              this.handleChartResize();
            }
          }
        });
        
        this.$nextTick(() => {
          if (this.$refs.chartContainer) {
            this.resizeObserver.observe(this.$refs.chartContainer);
          }
        });
      }
    },
    
    // 新增：图表容器大小变化处理
    handleChartResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    
    // 修改：初始化图表方法，确保正确初始化
    initChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.salesChart;
        if (!chartDom) {
          console.warn('图表容器未找到，延迟初始化');
          setTimeout(() => {
            this.initChart();
          }, 100);
          return;
        }
        
        // 如果已有图表实例，先销毁
        if (this.chartInstance) {
          this.chartInstance.dispose();
        }
        
        try {
          this.chartInstance = echarts.init(chartDom);
          console.log('ECharts图表初始化成功');
          
          // 监听窗口大小变化
          window.addEventListener('resize', () => {
            if (this.chartInstance) {
              this.chartInstance.resize();
            }
          });
        } catch (error) {
          console.error('ECharts初始化失败:', error);
        }
      });
    },
    
    // 修改：获取报表数据，添加日期参数
    async fetchReportData() {
      this.loading = true;
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          drugName: this.searchKeyword
        };
        
        // 添加日期范围参数
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0];
          params.endDate = this.dateRange[1];
        }
        
        console.log('请求参数:', params);
        
        const res = await dgsReportZY(params);
        if (res.code === 200) {
          // 接口返回数据结构适配
          const responseData = res.data;
          
          // 表格数据
          this.tableData = responseData.content || responseData.list || responseData || [];
          this.total = responseData.totalSize || responseData.total || 0;
          
          // 自动计算指标数据
          this.calculateMetrics();
          
          // 更新图表数据
          this.updateChart();
          
          this.$message.success('数据加载成功');
        } else {
          this.$message.error(res.message || '接口返回状态异常');
          this.loadDefaultData();
        }
      } catch (error) {
        console.error('获取报表数据失败:', error);
        this.$message.error('数据加载失败，请检查网络连接');
        this.loadDefaultData();
      } finally {
        this.loading = false;
      }
    },
    
    // 标签页切换处理
    handleTabClick(tab) {
      console.log('切换到标签页:', tab.name);
      
      // 如果是切换到图表标签页，确保图表已初始化并更新
      if (tab.name === 'chart') {
        this.$nextTick(() => {
          if (!this.chartInstance) {
            this.initChart();
          } else {
            this.chartInstance.resize(); // 确保图表尺寸正确
          }
          this.updateChart();
        });
      }
    },
    
    // 其他现有方法保持不变...
    // 计算指标数据
    calculateMetrics() {
      if (!this.tableData || this.tableData.length === 0) {
        this.resetMetrics();
        return;
      }
      
      // 利润总额 = 成本金额累加（期初成本 + 期末成本 + 入库成本 + 出库成本）
      this.metrics.totalProfit = this.tableData.reduce((sum, item) => 
        sum + (Number(item.startPurcAmt) || 0) + (Number(item.endPurcAmt) || 0) + 
        (Number(item.intoPurcAmt) || 0) + (Number(item.outPurcAmt) || 0), 0);
      
      // 日均总额 = 零售金额（期初零售 + 期末零售 + 入库零售 + 出库零售）
      const totalSales = this.tableData.reduce((sum, item) => 
        sum + (Number(item.startSaleAmt) || 0) + (Number(item.endSaleAmt) || 0) + 
        (Number(item.intoSaleAmt) || 0) + (Number(item.outSaleAmt) || 0), 0);
      this.metrics.dailyAverage = totalSales / 30; // 假设30天
      
      // 期初成本 = 期初成本总和
      this.metrics.unitPrice = this.tableData.reduce((sum, item) => 
        sum + (Number(item.startPurcAmt) || 0), 0);
      
      // 期初零售 = 期初零售总和
      this.metrics.transportCost = this.tableData.reduce((sum, item) => 
        sum + (Number(item.startSaleAmt) || 0), 0);
      
      // 期末成本 = 期末成本总和
      this.metrics.endCost = this.tableData.reduce((sum, item) => 
        sum + (Number(item.endPurcAmt) || 0), 0);
      
      // 期末零售 = 期末零售总和
      this.metrics.endSale = this.tableData.reduce((sum, item) => 
        sum + (Number(item.endSaleAmt) || 0), 0);
    },
    
    // 重置指标数据
    resetMetrics() {
      this.metrics = {
        totalProfit: 0,
        dailyAverage: 0,
        unitPrice: 0,
        transportCost: 0,
        endCost: 0,
        endSale: 0
      };
    },
    
    // 格式化数字显示
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';
      const numValue = Number(value);
      if (isNaN(numValue)) return '0';
      
      if (numValue >= 10000) {
        return (numValue / 10000).toFixed(1) + '万';
      }
      if (numValue >= 1000) {
        return (numValue / 1000).toFixed(1) + '千';
      }
      return numValue.toFixed(0);
    },
    
    // 加载默认数据（接口失败时的fallback）
    loadDefaultData() {
      this.tableData = [
        {
          id: '1',
          drugName: '阿莫中林胶囊',
          drugSpec: '0.25g*24粒',
          intoCnt: 100,
          unt: '盒',
          purcPric: 15.8,
          salePric: 25.5,
          startCnt: 50,
          startPurcAmt: 790,
          startSaleAmt: 1275,
          endCnt: 120,
          endPurcAmt: 1896,
          endSaleAmt: 3060,
          intoPurcAmt: 1580,
          intoSaleAmt: 2550,
          outCnt: 30,
          outPurcAmt: 474,
          outSaleAmt: 765,
          manuLotnum: '20231001',
          prodentpName: '华北制药',
          allotIntoCnt: 10,
          allotIntoPurcAmt: 158,
          allotIntoSaleAmt: 255,
          allotOutCnt: 5,
          allotOutPurcAmt: 79,
          allotOutSaleAmt: 127.5,
          type: '中药',
          status: '正常'
        }
      ];
      this.total = this.tableData.length;
      this.calculateMetrics();
      this.updateChart();
    },
    
    // 准备图表数据
    prepareChartData() {
      if (!this.tableData || this.tableData.length === 0) return null;
      
      // 按入库数量排序，取前10个药品展示
      const sortedData = [...this.tableData]
        .sort((a, b) => (Number(b.intoCnt) || 0) - (Number(a.intoCnt) || 0))
        .slice(0, 10);
      
      const drugNames = sortedData.map(item => item.drugName || '未知药品');
      const metricData = sortedData.map(item => Number(item[this.chartMetric]) || 0);
      
      return {
        drugNames,
        metricData
      };
    },
    
    // 更新图表
    updateChart() {
      if (!this.chartInstance) {
        console.warn('图表实例不存在，尝试初始化');
        this.initChart();
        if (!this.chartInstance) {
          console.error('图表初始化失败');
          return;
        }
      }
      
      const chartData = this.prepareChartData();
      if (!chartData) {
        console.warn('没有可用的图表数据');
        // 显示空状态
        this.chartInstance.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 16
            }
          }
        }, true);
        return;
      }
      
      let option = {};
      
      switch (this.chartType) {
        case 'bar':
          option = this.getBarOption(chartData);
          break;
        case 'pie':
          option = this.getPieOption(chartData);
          break;
        case 'line':
          option = this.getLineOption(chartData);
          break;
        case 'scatter':
          option = this.getScatterOption(chartData);
          break;
        case 'candlestick':
          option = this.getCandlestickOption(chartData);
          break;
        case 'sunburst':
          option = this.getSunburstOption(chartData);
          break;
        case 'boxplot':
          option = this.getBoxplotOption(chartData);
          break;
        default:
          option = this.getBarOption(chartData);
      }
      
      try {
        this.chartInstance.setOption(option, true);
        console.log('图表更新成功');
      } catch (error) {
        console.error('图表更新失败:', error);
      }
    },
    
    // 柱状图配置
    getBarOption(chartData) {
      return {
        title: {
          text: this.getMetricLabel() + '分析 - 柱状图',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            const data = params[0];
            return `${data.name}<br/>${this.getMetricLabel()}: ${data.value}`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: chartData.drugNames,
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          name: this.getMetricLabel()
        },
        series: [{
          name: this.getMetricLabel(),
          type: 'bar',
          data: chartData.metricData,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#5470c6' },
              { offset: 1, color: '#83bff6' }
            ])
          },
          label: {
            show: true,
            position: 'top'
          }
        }]
      };
    },
    
    // 饼图配置
    getPieOption(chartData) {
      const data = chartData.drugNames.map((name, index) => ({
        name: name,
        value: chartData.metricData[index]
      }));
      
      return {
        title: {
          text: this.getMetricLabel() + '分布 - 饼图',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle'
        },
        series: [{
          name: this.getMetricLabel(),
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['60%', '50%'],
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            formatter: '{b}: {c}'
          }
        }]
      };
    },
    
    // 获取指标标签
    getMetricLabel() {
      const labels = {
        intoCnt: '入库数量',
        outCnt: '出库数量',
        startCnt: '期初数量',
        startPurcAmt: '期初成本',
        startSaleAmt: '期初零售',
        endCnt: '期末数量',
        endPurcAmt: '期末成本',
        endSaleAmt: '期末零售'
      };
      
      return labels[this.chartMetric] || this.chartMetric;
    },
    
    // 处理窗口大小变化
    handleResize() {
      // 更新表格高度
      this.calculateTableHeight();
      
      // 更新图表尺寸
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    
    // 新增：计算表格高度
    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight;
        const searchHeaderHeight = 60; // 搜索栏高度
        const tabHeaderHeight = 40; // 标签页头部高度
        const padding = 40; // 内边距
        
        this.tableHeight = windowHeight - searchHeaderHeight - tabHeaderHeight - padding - 100;
      });
    },
    
    // 树节点点击事件
    handleNodeClick(data) {
      console.log('树节点点击:', data);
      this.searchKeyword = data.label;
      this.handleSearch();
    },
    
    // 搜索处理
    handleSearch() {
      this.currentPage = 1;
      this.fetchReportData();
    },
    
    // 刷新数据
    refreshData() {
      this.fetchReportData();
    },
    
    // 导出数据
    exportData() {
      this.$message.success('数据导出成功');
    },
    
    // 表格选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    
    // 查看操作
    handleView(row) {
      this.$message.info(`查看药品: ${row.drugName}`);
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchReportData();
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchReportData();
    },
    
    // 其他图表配置方法（简化版）
    getLineOption(chartData) {
      return {
        title: {
          text: this.getMetricLabel() + '趋势 - 折线图',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: chartData.drugNames
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: chartData.metricData,
          type: 'line',
          smooth: true
        }]
      };
    },
    
    getScatterOption(chartData) {
      return {
        title: {
          text: this.getMetricLabel() + '分布 - 散点图',
          left: 'center'
        },
        xAxis: {},
        yAxis: {},
        series: [{
          symbolSize: 20,
          data: chartData.metricData.map((value, index) => [index, value]),
          type: 'scatter'
        }]
      };
    },
    
    getCandlestickOption(chartData) {
      return this.getBarOption(chartData); // 简化处理
    },
    
    getSunburstOption(chartData) {
      return this.getPieOption(chartData); // 简化处理
    },
    
    getBoxplotOption(chartData) {
      return this.getBarOption(chartData); // 简化处理
    }
  }
};
</script>

<style lang="less" scoped>
.report-yk-container {
  height: 88vh;
  background: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.main-layout {
  height: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

// 左侧树形菜单样式
.left-sidebar {
  background: #f8f9fa;
  border-right: 1px solid #e6e8eb;
  padding: 0;
  overflow: hidden;
  
  .sidebar-header {
    padding: 15px;
    border-bottom: 1px solid #e6e8eb;
    background: white;
    
    .sidebar-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }
  
  .tree-container {
    height: calc(100% - 61px);
    overflow-y: auto;
    padding: 10px 0;
  }
}

// 右侧内容区域样式
.right-content {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

// 标签页容器样式
.tab-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  // 搜索区域样式
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    // border-bottom: 1px solid #e6e8eb;
    background: white;
    flex-shrink: 0;
    min-height: 60px;
    
    .search-left {
      display: flex;
      align-items: center;
      gap: 12px;
      
      // 日期范围选择器样式
      .date-range-picker {
        width: 240px;
      }
      
      .search-input {
        width: 280px;
      }
    }
    
    .search-right {
      .el-button {
        margin-left: 8px;
      }
    }
  }
  /deep/ .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .el-tabs__header {
      margin: 0;
      background: #f5f7fa;
      border-bottom: 1px solid #e6e8eb;
      flex-shrink: 0;
      
      .el-tabs__nav-wrap {
        // padding: 0 20px;
      }
    }
    
    .el-tabs__content {
      flex: 1;
      overflow: hidden;
      
      .el-tab-pane {
        height: 100%;
        overflow: hidden;
      }
    }
  }
  
  .tab-content {
    height: 100%;
    overflow: hidden;
  }
}

// 表格区域样式
.table-section {
  padding: 0 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  .table-header {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    // margin-bottom: 15px;
    flex-shrink: 0;
	.table-title{
		color: #303133;
	}
  }
  
  .el-table {
    flex: 1;
    overflow: auto;
    
    /deep/ .el-table__body-wrapper {
      overflow: auto;
    }
  }
  
  .pagination-container {
    // margin-top: 15px;
	padding: 12px;
    text-align: right;
    flex-shrink: 0;
  }
}

// 图表区域样式 - 修复宽度问题
.chart-section {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    flex-shrink: 0;
	.chart-title{
		color: #303133;
	}
  }
  
  .metrics-cards {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
    margin-bottom: 15px;
    flex-shrink: 0;
    
    .metric-card {
      .metric-content {
        display: flex;
        align-items: center;
        padding: 12px;
        
        .metric-icon {
          width: 40px;
          height: 40px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-size: 20px;
          color: white;
          
          &.profit { background: linear-gradient(135deg, #67c23a, #85ce61); }
          &.daily { background: linear-gradient(135deg, #409eff, #79bbff); }
          &.price { background: linear-gradient(135deg, #e6a23c, #ebb563); }
          &.cost { background: linear-gradient(135deg, #f56c6c, #f89898); }
          &.end-cost { background: linear-gradient(135deg, #909399, #c0c4cc); }
          &.end-sale { background: linear-gradient(135deg, #b37feb, #d3adf7); }
        }
      }
    }
  }
  
  // 修复：图表容器样式
  .chart-container {
    flex: 1;
    min-height: 300px;
    position: relative;
    overflow: hidden;
    
    .sales-chart {
      width: 100% !important;
      height: 100% !important;
      min-height: 400px;
    }
  }
}

// 响应式设计
@media (max-width: 1600px) {
  .metrics-cards {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}

@media (max-width: 1200px) {
  .metrics-cards {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .search-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    
    .search-left {
      width: 100%;
      justify-content: space-between;
    }
    
    .search-right {
      width: 100%;
      justify-content: flex-end;
    }
  }
}

@media (max-width: 768px) {
  .report-yk-container {
    padding: 10px;
  }
  
  .main-layout {
    flex-direction: column;
  }
  
  .left-sidebar {
    width: 100% !important;
    height: 200px;
  }
  
  .metrics-cards {
    grid-template-columns: 1fr !important;
  }
  
  .search-header {
    .search-left {
      flex-direction: column;
      gap: 8px;
      
      .date-range-picker,
      .search-input {
        width: 100%;
      }
    }
  }
}

// 表格特殊样式
.number-highlight {
  font-weight: 500;
  color: #3b3b3b;
}

.price-value {
  font-weight: 300;
  color: #67c23a;
}

.leave-active {
  color: #f56c6c;
  font-weight: 300;
}

/deep/ .el-table {
  .el-table__header-wrapper {
    th {
      background: #f5f7fa;
      color: #606266;
      font-weight: 600;
    }
  }
}
</style>